import React from 'react';
import {__GPYGet} from '../env.js'

class SelectCountry extends React.Component {

	constructor(props) {
	   super(props);
	   this.state = {
			      error: null,
			      isLoaded: false,
			      items: [],
						defaultLocale: this.props.defaultLocale===undefined?"DE":this.props.defaultLocale,
			    };
	  }

	componentDidMount() {
		__GPYGet("getAllowedCountys",(result) => {
				this.setState({isLoaded: true,items: result});
			}, (error) => {
				this.setState({isLoaded: false,error: error});
			}
		);
	}

	onChange(e) {
		this.props.doChange(e.target.value);
		this.setState({defaultLocale: e.target.value});
	}

  render () {
	  return (
			   <select onChange={this.onChange.bind(this)} value={this.state.defaultLocale} className="form-control">
			   			{this.state.isLoaded?this.state.items.map((result)=>
									<option key={result.Locale.localeString} value={result.Locale.localeString}>{result.Locale.displayCountry}</option>
							):""}
		     </select>
	  	)
  }
}
export default SelectCountry;
